.list {
  display: flex;
  flex-wrap: wrap;
  min-width: 400px;
}
